import {httpRequest} from "@/providers/http";

export const recoverPasswordService = async (email: string): Promise<void> => {
  await httpRequest({
    method: "POST",
    url: `/user/password-recovery/${encodeURIComponent(email)}`,
    auth: false,
  });
};
